<template>
  <div class="generate__popup">
    <vs-popup id="print-invoice" class="text-center" title="Print Label" button-accept="false" button-cancel="false" :active.sync="isActive">
      <hr style="background: lightgrey" />
      <div class="vx-row mt-3">
        <div class="vx-col w-full">
          <div class="vx-col md:w-2/4 px-8">
            <div class="vx-row mb-2">
              <vs-input icon="icon icon-list" type="number" v-model="total_label" icon-pack="feather" class="w-full" label="Total Label" name="Total Label" v-validate="'required'" />
              <span class="text-danger text-center text-sm" v-show="errors.has('Total Label')">{{ errors.first('Total Label') }}</span>
            </div>
          </div>
          <div class="float-center">
            <vs-button class="mr-2 vs-con-loading__container" @click="downloadPrint()" id="add-inventory-button" type="relief">Download Label</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'GeneratePopup',

  props: {
    productId: Array,
    saleId: Number,
    isModelShow: Boolean
  },

  data() {
    return {
      total_label: null
    }
  },

  computed: {
    isActive: {
      get() {
        return this.isModelShow
      },
      set(val) {
        this.$emit('update:isModelShow', val)
      }
    }
  },

  methods: {
    async downloadPrint() {
      if (!(await this.$validator.validate())) {
        //show message
        return false
      }

      const routeData = this.$router.resolve({
        name: 'pos-exit-print',
        params: {
          productIds: this.productId.join('-'),
          saleId: this.saleId,
          number: this.total_label
        }
      })

      window.open(routeData.href, '_blank')
    }
  },

  beforeRouteLeave(_, __, next) {
    this.isActive = false
    next()
  }
}
</script>

<style>
</style>